export default __webpack_public_path__ + "static/media/fondo-main.b5f37178.png";